export default {
  label: {
    noPostsLabel: 'Nenhuma publicação encontrada',
  },
};
